<template>
  <div class="address">
    <div
      class="address_item"
      v-for="item in addressList"
      :key="item.id"
      :class="{ red_bg: item.is_checked == 1 }"
      @click="checkUserAddress(item)"
    >
      <div style="display:flex">
        <span v-show="item.type">{{ itemType(item.type) }}</span>
        <div class="defult">
          <span @click="setDefaultAddress(item)">
            {{ item.is_default == "1" ? "默认" : "设为默认" }}
          </span>
        </div>
        <span
          @click.stop="
            showWriteAddress = true;
            id = item.id;
          "
          >修改</span
        >
        <span @click.stop="delAddress(item.id)">删除</span>
      </div>
      <div>
        <b>{{ item.name }}</b>
        {{ item.phone }}
      </div>
      <div>
        <div>
          {{ item.zone.name || "" }}{{ item.city.name || ""
          }}{{ item.area.name || "" }}{{ item.town.name || "" }}
        </div>
        <div style="word-break: break-all;">
          {{ item.address && item.address }}
        </div>
      </div>
      <div class="err-hint" v-if="item.valid === 0">地址已失效，请修改地址</div>
    </div>
    <div
      class="add_address"
      @click="
        id = null;
        showWriteAddress = true;
      "
    >
      <i class="el-icon-plus"></i>
      <p>增加新地址</p>
    </div>
    <address-edit
      :id="id"
      v-if="showWriteAddress"
      @close="showWriteAddress = false"
      @getAddressList="getAddressList"
    ></address-edit>
  </div>
</template>
<script>
import addressEdit from "./address-edit.vue";
export default {
  components: {
    addressEdit
  },
  props: {
    checkAddress: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      addressList: [],
      loadingOption: { background: "rgba(0,0,0,0)" },
      showWriteAddress: false,
      id: null,
      checkPayment: ""
    };
  },
  mounted() {
    this.getAddressList();
  },
  methods: {
    itemType(type) {
      if (type == 1) {
        return "家";
      } else if (type == 2) {
        return "公司";
      } else if (type == 3) {
        return "父母家";
      } else if (type == 4) {
        return "学校";
      }
    },
    getAddressList() {
      this.$reqGet("api/store/address").then(res => {
        this.addressList = res.data.data;
        this.addressList.forEach(address => {
          this.validAddress(address);
        });
        if (this.addressList.length === 0) {
          return;
        }
        let key = false;
        if (this.checkAddress.id) {
          this.addressList.map(item => {
            if (item.id == this.checkAddress.id) {
              item.is_checked = 1;
              key = true;
            }
          });
        }
        if (!key) {
          this.addressList.map(item => {
            if (item.is_default == 1) {
              item.is_checked = 1;
              key = true;
            }
          });
        }
        if (!key) {
          this.addressList[0].is_checked = 1;
          key = true;
        }
      });
    },
    validAddress(address) {
      if (
        !address.zone ||
        !address.city ||
        !address.area ||
        (address.town_id !== 0 && !address.town)
      ) {
        address.valid = 0;
        address.zone = address.zone || {};
        address.city = address.city || {};
        address.area = address.area || {};
        address.town = address.town || {};
      }
      address.town = address.town || {};
    },
    delAddress(id) {
      this.$confirm("请确认是否删除地址?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$reqDel("api/store/address/" + id).then(res => {
          if (res.data.success) {
            this.getAddressList();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.$bus.emit("updateAddressList");
          }
        });
      });
    },
    setDefaultAddress(item) {
      if (item.valid === 0) {
        return;
      }
      let sbzRegion = {
        label:
          (item.zone.name || "") +
          " " +
          (item.city.name || "") +
          " " +
          (item.area.name || "") +
          " " +
          (item.town.name || ""),
        value:
          item.zone_id +
          "_" +
          item.city_id +
          "_" +
          item.area_id +
          "_" +
          item.town_id
      };
      this.$util.setLocalStorage({ sbzRegion: JSON.stringify(sbzRegion) });
      this.$reqPost("api/store/address/setdefault", {
        address_id: item.id
      }).then(res => {
        if (res.data.success) {
          this.$message({
            message: "设置成功",
            type: "success"
          });
          this.getAddressList();
        }
      });
    },
    checkUserAddress(item) {
      if (item.valid === 0) {
        this.$alert("地址已失效，请修改地址", "", {
          confirmButtonText: "确定"
        });
        return;
      }
      this.addressList.map(item => {
        if (item.is_checked == 1) {
          item.is_checked = 0;
        }
      });
      this.$set(item, "is_checked", 1);
      this.$bus.emit("change-user-address", item);
    }
  }
};
</script>

<style lang="less" scoped>
.address {
  display: flex;
  flex-wrap: wrap;
  .address_item {
    width: 300px;
    padding: 10px;
    padding-top: 20px;
    box-sizing: border-box;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    background-image: url("../assets/images/default_bg.png");
    background-size: 100% 100%;
    > div:first-child {
      > span:first-child {
        color: #fff;
        background-color: #ccc;
        padding: 2px 4px;
        margin-right: 18px;
      }
      .defult {
        flex: 1;
        span:first-child {
          padding: 2px 4px;
          color: #e2333f;
          border: 1px solid #e2333f;
          cursor: pointer;
        }
      }
      span:nth-child(3) {
        margin-left: 40px;
        margin-right: 20px;
        cursor: pointer;
      }
      span:nth-child(4) {
        cursor: pointer;
      }
    }
    > div:nth-child(2) {
      margin-top: 30px;
      border-bottom: 1px solid #eee;
      color: #222;
      padding-bottom: 5px;
      b {
        font-weight: normal;
      }
    }
    div:nth-child(3) {
      margin-top: 5px;
      color: #222;
      line-height: 24px;
    }
  }
  .red_bg {
    background-image: url("../assets/images/check_bg.png");
  }
  .add_address {
    width: 300px;
    height: 180px;
    text-align: center;
    background: rgba(255, 255, 255, 1);
    border: 2px dashed rgba(238, 238, 238, 1);
    padding-top: 50px;
    box-sizing: border-box;
    cursor: pointer;
    i {
      font-size: 38px;
      color: #bbb;
    }
    p {
      color: #bbb;
    }
  }
}

.red_word {
  color: #fc0010;
}

.el-radio /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #e2333f;
  background-color: #e2333f;
}
.el-radio /deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #666;
}
.err-hint {
  color: #e2333f;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/address-list.vue